<template>
  <div class="grow">
    <div class="st-window">
      <div class="header">
        <span class="text">{{ $t('stranger.videoclub.title') }}</span>
        <div class="close-button">
          <button class="st-button" @click="close()">X</button>
        </div>
      </div>
      <div class="content st-scrollbar">
        <div>
          <div class="form">
            <input type="text" class="mb-3" v-model="filter" :placeholder="$t('stranger.videoclub.filter')">
          </div>
          <div class="mobile-visible-only">
            <v-row class="k-swipe-anim">
              <v-col cols="9" class="st-help-text" >{{ $t('stranger.videoclub.swipe_help') }}</v-col>
              <v-col cols="3">
                <img class="wobble-hor-bottom" src="/stranger/assets/images/ST_SWIPE.png" />
              </v-col>
            </v-row>
          </div>
          <div class="k-table">
            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-left">{{ $t("stranger.videoclub.firstname") }}</th>
                  <th class="text-left">{{ $t("stranger.videoclub.lastname") }}</th>
                  <th class="text-left">{{ $t("stranger.videoclub.movie") }}</th>
                  <th class="text-left">{{ $t("stranger.videoclub.date") }}</th>
                  <th class="text-left">{{ $t("stranger.videoclub.member") }}</th>
                  <th class="text-left">{{ $t("stranger.videoclub.secret") }}</th>                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="entry in filteredEntries"
                  :key="`${entry.movie}-${entry.firstname}-${entry.lastname}-${entry.date}`"
                >
                  <td>{{ entry.firstname }}</td>
                  <td>{{ entry.lastname }}</td>
                  <td class="movie">{{ entry.movie }}</td>
                  <td class="date">{{ toDateString(entry.date) }}</td>
                  <td>{{ entry.member }}</td>
                  <td>{{ entry.secret }}</td>                  
                </tr>
              </tbody>
            </v-simple-table>
          </div>          


        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import currentGameMixin from "@/mixins/currentGameMixin";
  import axios from "axios";

  export default {
    name: "VideoClub",

    components: {},

    mixins: [currentGameMixin],

    data: () => ({
      entries: [],
      filter: '',
    }),

    methods: {
      close() {
        this.$router.push({ name: 'stranger-home' });
      },
      toDateString(date) {
        date = `19${date.substring(6, 8)}-${date.substring(3, 5)}-${date.substring(0, 2)}`;

        const d = new Date(`${date}T00:00:00`);
        return this.$strangerStore.formatDate(d, this.$t('stranger.videoclub.date_format'))
      }
    },

    computed: {
      filteredEntries: function() {
        return this.entries.filter((v) => {
          if (this.filter.trim() === '') return true;

          return v.firstname.toLowerCase().includes(this.filter.toLowerCase()) ||
                 v.lastname.toLowerCase().includes(this.filter.toLowerCase()) ||
                 v.date.toLowerCase().includes(this.filter.toLowerCase()) ||
                 v.movie.toLowerCase().includes(this.filter.toLowerCase()) ||
                 v.member.toLowerCase().includes(this.filter.toLowerCase()) ||
                 v.secret.toString().toLowerCase().includes(this.filter.toLowerCase());

        });
      }
    },

    watch: {

    },

    async mounted() { 
      const { data } = await axios.get('/stranger/data/videoclub.json');
      this.entries = data.sort((a, b) => {
        const sa = `19${a.date.substring(6, 8)}-${a.date.substring(3, 5)}-${a.date.substring(0, 2)}`;
        const sb = `19${b.date.substring(6, 8)}-${b.date.substring(3, 5)}-${b.date.substring(0, 2)}`;
        if (sa < sb) {
          return -1;
        }
        if (sa > sb) {
          return 1;
        } 
        return 0;       
      });
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/css/stranger.scss';

  .st-window {
    .header {
      .text {
        width: calc(100% - 60px);
      }
    }

    .content {
      max-height: 400px;
      overflow-y: scroll;
      overflow-x: clip;
      padding: 0px;

      img {
        max-width: 220px;
      }

      .k-swipe-anim {
        margin-top: 0px;
        margin-bottom: 12px;
      }
      .st-help-text {
        color: $light-color;
      }

      ::v-deep table {
        margin-top: 10px !important;
        border-radius: 0px;

        th {
          font-size: 10px !important;
          padding: 0 5px !important;
        }
        
        td {
          font-size: 10px !important;
          padding: 0 5px !important;          
          text-align: left;

          &.date {
            width: 100px;
            min-width: 100px;
          }

          &.movie {
            width: 250px;
            min-width: 200px;
          }          
        }
      }
      
      .form {
        padding-top: 12px;
        text-align: right;
        padding-right: 12px;

        input[type="text"] {
          border: 2px solid #fff;
          border-radius: 0px;
          background: #ccc;
          color: #000;
          padding: 8px;
          width: 200px;
        }

        .st-button {
          margin-top: 12px;
          padding-top: 2px;
        }
      }      
    }
  }

  @media (max-width: 600px) { 
    .st-window .header .text {
        font-size: 12px;
        padding-top: 0px;
      }
    }

</style>
  